/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

const ACTIONABLE = ['Assessment', 'Request', 'Task'];
const CONFIRMABLE = ['Audit', 'Vendor', ...ACTIONABLE];

export const confirmObjectStatusChange = async (
  bulkEdit: boolean | number,
  type: string,
  newStatus: string,
  direction?: boolean
) => {
  if (CONFIRMABLE.includes(type)) {
    // When bulk editing, we need plural object name, but for now this will do.
    const typeName = type + (bulkEdit ? 's' : '');
    const demonstrative = bulkEdit > 1 ? 'these' : 'this';
    let msg = 'Are you sure you want to move ' + `${demonstrative} ${typeName} to ${newStatus}?`;

    if (ACTIONABLE.includes(type)) {
      // When bulk editing there might be multiple object types and multiple
      // previous values, so we need the most general copy to cover all cases.
      const actionCopy = bulkEdit ? 'reset or bypass' : direction ? 'reset' : 'bypass';

      const roleCopy = (type !== 'Assessment' ? 'reviewers or ' : '') + 'verifiers';

      msg += `\n\nThis might cause a ${actionCopy} of all ${roleCopy}.`;
    }

    if (!(await window.GGRC.zenModal.confirm(msg))) {
      return Promise.resolve(false);
    }
  }

  return Promise.resolve(true);
};
